import { resourceQueryParamName } from 'constants/resourceQueryNames';
import useInvestigationEnvelopes from 'hooks/investigations/useInvestigationEnvelopes';
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';
import { getNavParamsByResource } from 'selectors/nav';

const InvestigationEnvelopesListCount: React.FC = () => {
  const { data, isLoading } = useInvestigationEnvelopes();

  const navParams = useSelector(
    getNavParamsByResource(resourceQueryParamName.investigationEnvelopes)
  );
  const offset = parseInt(navParams.offset as string, 10);

  if (!data) return null;

  return (
    <div className={`${isLoading ? 'text-litlingo-gray-2' : ''}`}>
      <span className="font-bold">{` ${data.records.length === 0 ? 0 : offset + 1}-${
        offset + data.records.length
      }`}</span>
      {` of ${
        data.count >= 10000
          ? '+10,000'
          : pluralize('message'.split(' ').map(capitalize).join(' '), data.count, true)
      }`}
    </div>
  );
};

export default InvestigationEnvelopesListCount;
